export enum ChatStatusEnum {
  New = 'New',
  Pending = 'Pending',
  Open = 'Open',
  Closed = 'Closed',
  Cancelled = 'Cancelled',
}
